<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
  <p-progressSpinner styleClass="custom-spinner size-16" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s">
  </p-progressSpinner>
</div>
